import { Component } from 'react';
import debounce from 'lodash/debounce';

class RenderByScreenSize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLargeScreen: false,
    };

    this.handleResize = debounce(this.updateScreenState);
  }

  componentDidMount() {
    this.updateScreenState();

    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  updateScreenState = () => {
    this.setState({
      isLargeScreen: window.matchMedia('(min-width: 992px)').matches,
    });
  };

  render() {
    const { renderLargeScreen, renderSmallScreen } = this.props;
    const { isLargeScreen } = this.state;

    return isLargeScreen ? renderLargeScreen() : renderSmallScreen();
  }
}

RenderByScreenSize.defaultProps = {
  renderLargeScreen: () => null,
  renderSmallScreen: () => null,
};

export default RenderByScreenSize;
